import styled from 'styled-components'

const Section = styled.div`
  background: white;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  padding: ${({ theme }) => theme.spacing.lg};
`

const SectionTitle = styled.h3`
  margin: 0 0 ${({ theme }) => theme.spacing.md} 0;
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.primary};
`

const PipelineGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 0.5rem;
`

interface PipelineCardProps {
    bgColor: string
}

const PipelineCard = styled.div<PipelineCardProps>`
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.md};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  text-align: center;
  cursor: pointer;
  transition: transform ${({ theme }) => theme.transitions.normal},
              box-shadow ${({ theme }) => theme.transitions.normal};
  background: ${({ bgColor }) => bgColor};
  color: white;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
`

const PipelineCount = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.xl};
  font-weight: 700;
`

const PipelineLabel = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const NoData = styled.div`
  text-align: center;
  padding: ${({ theme }) => theme.spacing.lg};
  color: ${({ theme }) => theme.colors.textMuted};
  font-size: ${({ theme }) => theme.fontSizes.sm};
`

interface PipelineItem {
    name: string
    count: number
    color: string
}

interface PipelineSectionProps {
    stages?: PipelineItem[]
    pipeline?: PipelineItem[]
    incompleteCount?: number
    onStageClick?: (stage: string) => void
    onIncompleteClick?: () => void
}

export const PipelineSection: React.FC<PipelineSectionProps> = ({
    stages,
    pipeline,
    incompleteCount,
    onStageClick,
    onIncompleteClick,
}) => {
    const items = stages || pipeline || []

    if (items.length === 0) {
        return (
            <Section>
                <NoData>Sin datos de pipeline disponibles</NoData>
            </Section>
        )
    }

    return (
        <Section>
            <PipelineGrid>
                {items.map((stage) => (
                    <PipelineCard
                        key={stage.name}
                        bgColor={stage.color}
                        onClick={() => onStageClick?.(stage.name)}
                    >
                        <PipelineCount>{stage.count}</PipelineCount>
                        <PipelineLabel title={stage.name}>{stage.name}</PipelineLabel>
                    </PipelineCard>
                ))}
                {incompleteCount != null && incompleteCount > 0 && (
                    <PipelineCard
                        bgColor="#FF9800"
                        onClick={() => onIncompleteClick?.()}
                    >
                        <PipelineCount>{incompleteCount}</PipelineCount>
                        <PipelineLabel title="Incompletas">⚠️ Incompletas</PipelineLabel>
                    </PipelineCard>
                )}
            </PipelineGrid>
        </Section>
    )
}
